import type { I18nTranslation } from '@crehana/i18n';

import { en } from './locale-en';
import { es } from './locale-es';
import { pt } from './locale-pt';

const locales: I18nTranslation = { es, pt, en };

export * from './constants';
export * from './types';
export default locales;
